// Adapted from davinci-elections apps/web/src/theme/recipes/drawer.ts @ 6e23f58
import { drawerAnatomy as parts } from '@chakra-ui/react/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

// The drawer is the phone form of the sidebar: the same chrome surface, raised over the page.
const baseStyle = {
  content: {
    bg: 'bg.chrome',
    boxShadow: 'raised',
  },
}

export const Drawer = defineSlotRecipe({
  slots: parts.keys(),
  base: baseStyle,
})
